import { render, staticRenderFns } from "./ObservationOverlay.vue?vue&type=template&id=5063d11a&"
import script from "./ObservationOverlay.vue?vue&type=script&lang=js&"
export * from "./ObservationOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports